import CreateGlue4Office from "./glue4office";
import { version } from "./version";

// add version num to factory function
(CreateGlue4Office as any).version = version;

if (typeof window !== "undefined") {
    (window as any).Glue4Office = CreateGlue4Office;
}

// add default library for ES6 modules
(CreateGlue4Office as any).default = CreateGlue4Office;

export default CreateGlue4Office;
